(function (module) {
    'use strict';

    function playlistsTimelineCtrl() {
    }

    module
        .component('playlistsTimeline', {
            templateUrl: '/js/components/playlists-timeline/playlists-timeline.html',
            controller: playlistsTimelineCtrl,
            bindings: {
                mainArray: '<',
                playlistDuration: '<'

            }
        });
})(angular.module('rocket.components'));
